export const Constants = {
       login:
       {
              LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
              LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
              LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
       },
      
       container:
       {
              CONTAINER_REQUEST: 'CONTAINER_REQUEST',
              CONTAINER_SUCCESS: 'CONTAINER_SUCCESS',
              CONTAINER_FAILURE: 'CONTAINER_FAILURE',
       },
       containerTripData: {
              CONTAINER_DATA_SUCCESS: 'CONTAINER_Trip_SUCCESS',
       },
       truckAppointmentDetails: {
              TRUCK_APPOINTMENT_DETAILS: 'TRUCK_APPOINTMENT_DETAILS_SUCCESS',
       },
       manageSubscriptionDetails: {
              MANAGE_SUBSCRIPTION_DETAILS: ' MANAGE_SUBSCRIPTION_DETAILS_SUCCESS',
       },
       subscriptionBasePlan: {
              SUBSCRIPTION_BASE_PLAN: 'SUBSCRIPTION_BASE_PLAN_SUCCESS'
       },
       addProfile: {
              ADD_PROFILE: 'ADD_PROFILE_SUCCESS'
       },
       manageProfile: {
              MANAGE_PROFILE: 'MANAGE_PROFILE_SUCCESS'
       },
       userProfileInfo:{
              USER_PROFILE_INFO : 'USER_PROFILE_INFO_SUCCESS'
       },
       loader: {
              LOADER_REQUESTER: 'LOADER_REQUESTER',

       }
}